/**
 * Retorna o nome do ícone baseado no tipo de marcador.
 * Para tipo "interest" retorna um ícone de coração,
 * para "avoid" retorna um ícone de erro,
 * e para outros casos retorna um ícone padrão de cartão.
 */
export const getIconByType = (type: "interest" | "avoid") => {
    if (type === "interest") return "rioglyph-heart";
    if (type === "avoid") return "rioglyph-error-sign";
    return "rioglyph-drivercard-in";
};
